import * as React from 'react';
import { Widget } from '@typeform/embed-react';

import {
  Lang,
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

import Setup from '../../../config/Setup.config';

export default function TypeForm(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  return (
    <Widget
      id={props.id[lang]}
      style={{
        width: '100%',
        height: size.width < Breakpoint.xxl
          ? 'calc(100svh - 80px)'
          : 'calc(100svh - 125px)',
      }}
    />
  );
}
